import {Component, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Apollo, QueryRef} from "apollo-angular";
import {DataFormatService} from "../services/data-format.service";
import {MatSort} from "@angular/material/sort";
import {MatDialog} from "@angular/material/dialog";
import {AssignmentsModalComponent} from "../components/assignments-modal/assignments-modal.component";
import {FundService} from "../funds/fund-service.service";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";
import {SimpleListModalComponent} from "../components/simple-list-modal/simple-list-modal.component";
import {Subscription} from "rxjs";
import {AddSyndicationsPipelineComponent} from "./add-syndications-pipeline/add-syndications-pipeline.component";
import {DatePipe} from "@angular/common";
import {SyndicationsPipelineService, UpdateSyndicationsPipelineMode} from "./syndications-pipeline.service";

@Component({
    selector: 'app-syndications-pipeline',
    templateUrl: './syndications-pipeline.component.html',
    styleUrls: ['./syndications-pipeline.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SyndicationsPipelineComponent implements OnInit {
  @ViewChild('dataSort') public dataSort: MatSort;
  public projects:any = {}
  public totals:any = {}
  public fund:any;
  private fundProjectStates:any[] = [];
  public tableColumns:string[] = ['actions', 'project', 'fund', 'credit_type', 'ownership', 'revenue_year', 'gross_equity', 'closing_date', 'warehoused', 'admitted_date', 'location', 'county', 'sponsor', 'debt', 'ppc', 'credit_date']
  public querySubscription:Subscription;
  public queryRef: QueryRef<any,any>;
  public syndicationsSequences:any[] = []
  private credits:any[] = []
  public permissions:any

  public permissionsSub: Subscription;
  public projectsSub: Subscription;
  public statesSub: Subscription;
  public creditsSub: Subscription;
  public sequencesSub: Subscription;
  constructor(private apollo: Apollo, private dataFormat: DataFormatService, private dialog: MatDialog, private datePipe: DatePipe, private fundService: FundService, private _snackBar: MatSnackBar, public syndicationsService: SyndicationsPipelineService) {
  }
  ngOnInit() {
    //this._getSyndicationsProjects()
    this.syndicationsService.getSyndicationsProjects();
    this.permissionsSub = this.syndicationsService.permissions$.subscribe((result) => this.permissions = result)
    this.creditsSub = this.syndicationsService.credits$.subscribe((result) => this.credits = result)
    this.projectsSub = this.syndicationsService.projects$.subscribe((result) => {
      this.projects = result
    })
    this.statesSub = this.syndicationsService.fundProjectStates$.subscribe((result) => this.fundProjectStates = result)
    this.sequencesSub = this.syndicationsService.syndicationsSequences$.subscribe((result) => this.syndicationsSequences = result)
  }

  // private _getSyndicationsProjects(){
  //   this.queryRef = this.apollo.watchQuery({
  //     query: get_project_credit_outlets,
  //
  //   })
  //   this.querySubscription = this.queryRef.valueChanges.subscribe((data:any) => {
  //     this.permissions = data.data.me.fundPermissions;
  //     this.credits = data.data.syndicationsProjectCredits
  //     this.projects = this._setSyndicationsProjects(this.credits);//
  //     this.fundProjectStates = data.data.fund_project_states;
  //     this.syndicationsSequences = data.data.statusesBySequence
  //   })
  // }



  private _setSyndicationsProjects(creditOutlets:any){
    let dataObject:any = {}
    let compareSort = (object:any)=> {
      let stateOrder = ['Specified', 'Unspecified', 'Unlikely', 'Admitted', 'Unassigned']
      let stateKeys = Object.keys(object)
      let sortedOrder:any = {}
      stateKeys.sort((a:string, b:string) => {
        const indexA = stateOrder.indexOf(a)
        const indexB = stateOrder.indexOf(b)
        if(indexA === -1 && indexB === -1){
          return a.localeCompare(b)
        } else if (indexA === -1){
          return 1
        } else if (indexB === -1){
          return -1;
        } else {
          return indexA - indexB
        }
      })
      for(const key of stateKeys){
        sortedOrder[key] = object[key];
      }
      return sortedOrder;
    }
    let subSort = (object:any)=> {
      let statusOrder = ['Closed', 'Signed LOI', 'Verbal', 'LOI Pending', 'Placement Committee Approved', 'Pre-LOI', 'App Letter']
      let stateKeys = Object.keys(object)
      let sortedOrder:any = {}
      for(let o = 0; o < stateKeys.length; o++){
        let subKeys = Object.keys(object[stateKeys[o]])
        subKeys.sort((a:string, b:string) => {
          const indexA = statusOrder.indexOf(a)
          const indexB = statusOrder.indexOf(b)
          if(indexA === -1 && indexB === -1){
            return a.localeCompare(b)
          } else if (indexA === -1){
            return 1
          } else if (indexB === -1){
            return -1
          } else {
            return indexA - indexB
          }
        })
        for(let key of subKeys){
          if(!sortedOrder.hasOwnProperty(stateKeys[o])){
            sortedOrder[stateKeys[o]] = {}
          }
          sortedOrder[stateKeys[o]][key] = {}
          sortedOrder[stateKeys[o]][key] = object[stateKeys[o]][key]
        }
      }

      return sortedOrder;
    }
    creditOutlets = this._combineCredts(creditOutlets)
    let sortedOutlets = this._sortSubCredits(creditOutlets)

    for(let i = 0; i < sortedOutlets.length; i++){

      let outlet = sortedOutlets[i];
      let credit = sortedOutlets[i].projectCredit;
      let project = sortedOutlets[i].projectCredit.project;
      let state = sortedOutlets[i].fundProjectState == null ? 'Unassigned' : sortedOutlets[i].fundProjectState.name == 'Exited' || sortedOutlets[i].fundProjectState.name == 'Admitted' ? 'Unspecified' : sortedOutlets[i].fundProjectState.name
      let isAdmitted = sortedOutlets[i].fundProjectState!==null && sortedOutlets[i].fundProjectState.name == 'Admitted'
      let taxCreditType = sortedOutlets[i].projectCredit.taxCreditType.level + " "
        + sortedOutlets[i].projectCredit.taxCreditType.name;

      let location = this._getLocation(project);
      let projectData:any = {
        project: project.name,
        projectid: project.id,
        projecturl: this.dataFormat.formatLink(project),
        sponsor: project.sponsor[0].sponsor.nickname,
        sponsorurl: this.dataFormat.formatLink(project.sponsor[0].sponsor),
        project_status: this.fetchProjectStatus(project.projectStatuses).name,
        project_status_id: this.fetchProjectStatus(project.projectStatuses).id,
        certificated_name: outlet.certificatedOutlet ? outlet.certificatedOutlet.organization.name : null,
        certificated_outlet_id: outlet.certificatedOutlet ? outlet.certificatedOutlet.organization.id : null,
        certificatedurl: outlet.certificatedOutlet ? this.dataFormat.formatLink(outlet.certificatedOutlet) : null,
        fund_name: outlet.fund ? outlet.fund.name : null,
        fund_id: outlet.fund ? outlet.fund.id : null,
        fundurl: outlet.fund ? this.dataFormat.formatLink(outlet.fund) : null,
        ownership: ((outlet.estimOwnership && outlet.estimOwnership!== null) ? outlet.estimOwnership : (outlet.ownership || 0)) * .01,
        estimated_gross_equity: outlet.estimated_gross_equity,
        credit_type: taxCreditType,
        gross_equity: this.fundService.setGrossEquity(outlet, credit,credit.certificated, this.fetchProjectStatus(project.projectStatuses).name),
        revenue_year: outlet.revenue_year,
        admitted_date: outlet.admitted_date,
        ppc: this.fundService.setPpc(project, credit, outlet, this.fetchProjectStatus(project.projectStatuses).name),
        credit_id: credit.id,
        taggedParticipants: project.taggedParticipants,
        loadWeight: outlet.fund!==null ? outlet.fund.non_certificated_load : outlet.certificatedOutlet!==null ? outlet.certificatedOutlet.certificated_load : 0,
        location: location.locationString,
        county: location.county,
        credit_date: project.ltmodels[0]?.kpiset.kpiset_detail?.credit_start_date ?? null,
        debt: this.fundService.setHardDebt(project, this.fetchProjectStatus(project.projectStatuses).name),
        warehouse: outlet.warehoused,
        closing_date: project.pipelineProjects[0].closingDate[0]?.date ?? null,
        notes: project.projectDetail.syndications_notes,
        subCredits: [],
        isExpanded: false,
      }

      if(dataObject.hasOwnProperty(state)){
        if(dataObject[state].hasOwnProperty(projectData.project_status)){
          let hasSecondaryCredit = dataObject[state][projectData.project_status].find((ob:any) => {
            if((projectData.projectid === ob.projectid) && (ob.credit_type.split(" ")[0]===projectData.credit_type.split(" ")[0])){
              if((projectData.fund_id!==null && ob.fund_id!==null) && (projectData.fund_id == ob.fund_id)){
                return ob;
              }
              if((projectData.certificated_outlet_id!==null && ob.certificated_outlet_id!==null) && (projectData.certificated_outlet_id == ob.certificated_outlet_id)){
                return ob;
              }
              if((projectData.certificated_outlet_id==null && ob.certificated_outlet_id==null) && (projectData.fund_id==null && ob.fund_id==null)){
                return ob;
              }
            }
          })

          if(hasSecondaryCredit){
            let sameSubCred = hasSecondaryCredit.subCredits.filter((sub:any) => sub.credit_id == projectData.credit_id)
            if(hasSecondaryCredit.credit_id!==projectData.credit_id && sameSubCred.length==0){
              hasSecondaryCredit.subCredits.push(projectData);
            }
          } else {
            dataObject[state][projectData.project_status].push(projectData)
            dataObject[state][projectData.project_status].sort((a:any, b:any) => a.project < b.project ? -1 : 1)
          }
        } else {
          dataObject[state][projectData.project_status] = []
          dataObject[state][projectData.project_status].push(projectData)
          dataObject[state][projectData.project_status].sort((a:any,b:any) => a.project < b.project ? -1 : 1)
        }
      } else {
        dataObject[state] = {}
        dataObject[state][projectData.project_status] = []
        dataObject[state][projectData.project_status].push(projectData)
        dataObject[state][projectData.project_status].sort((a:any, b:any) => a.project < b.project ? -1 : 1)
      }

    }
    subSort(dataObject)
    let obj = {...subSort(dataObject)}
    let sortedObj = {...compareSort(obj)}
    this.querySubscription.unsubscribe();
    return sortedObj;
  }

  public getTotals(event:any){
    let totals:any = {};
    let statusKeys = Object.keys(event);
    let total_gross_equity = 0;
    let totalPpc = 0;
    let totalHardDebt = 0;
    let ppcDivisible = 0;
    let debtDivisible = 0;
    let subtotals:any = {}
    statusKeys.forEach((key:any) => {
      let subPpcDivisible = 0;
      let subDebtDivisible = 0;
      let subTotalPpc = 0;
      let subTotalDebt = 0;
      if(!subtotals.hasOwnProperty(key)){
        subtotals[key] = {
          total_gross_equity: 0,
          avgPpc:0,
          avgDebt:0
        }
      }
      for(let s = 0; s < event[key].length; s++){
        subtotals[key].total_gross_equity += event[key][s].estimated_gross_equity!==null && event[key][s].estimated_gross_equity!==0 ? event[key][s].estimated_gross_equity : event[key][s].gross_equity!==null ? event[key][s].gross_equity : 0;
        if(event[key][s].ppc!==null){
          ppcDivisible += event[key][s].gross_equity;
          subPpcDivisible += event[key][s].gross_equity;
          totalPpc += (parseFloat(event[key][s].ppc) * event[key][s].gross_equity);
          subTotalPpc += (parseFloat(event[key][s].ppc) * event[key][s].gross_equity);
        }

        if(event[key][s].debt!==null){
          subDebtDivisible += event[key][s].gross_equity;
          debtDivisible += event[key][s].gross_equity;
          totalHardDebt += event[key][s].debt * event[key][s].gross_equity;
          subTotalDebt += event[key][s].debt * event[key][s].gross_equity;
        }

        total_gross_equity += event[key][s].estimated_gross_equity!==null && event[key][s].estimated_gross_equity!==0 ? event[key][s].estimated_gross_equity : event[key][s].gross_equity!==null ? event[key][s].gross_equity : 0;

        if(event[key][s].subCredits.length !== null && event[key][s].subCredits.length>0){
          event[key][s].subCredits.forEach((credit:any) => {
            subtotals[key].total_gross_equity += credit.gross_equity!==null ? credit.gross_equity : 0;
            total_gross_equity += credit.gross_equity!==null ? credit.gross_equity : 0;
            if(credit.ppc!==null){
              ppcDivisible += credit.gross_equity !== null ? credit.gross_equity : 0;
              subPpcDivisible += credit.gross_equity !== null ? credit.gross_equity : 0;
              totalPpc += (parseFloat(event[key][s].ppc) * (credit.gross_equity !== null ? credit.gross_equity : 0));
              subTotalPpc += (parseFloat(event[key][s].ppc) * (credit.gross_equity !== null ? credit.gross_equity : 0));
            }
            if(credit.debt!==null){
              subDebtDivisible += credit.gross_equity !== null ? credit.gross_equity : 0;
              debtDivisible += credit.gross_equity !== null ? credit.gross_equity : 0;
              totalHardDebt += credit.debt * (credit.gross_equity!==null ? credit.gross_equity : 0);
              subTotalDebt += credit.debt * (credit.gross_equity !== null ? credit.gross_equity : 0);
            }
          })
        }

      }
      if((subTotalPpc/subPpcDivisible) >= 0){
        subtotals[key].avgPpc += subTotalPpc / subPpcDivisible;
      }
      if((subTotalDebt/subDebtDivisible) >= 0){
        subtotals[key].avgDebt += subTotalDebt / subDebtDivisible;
      }
    });
    totals['total_gross_equity'] = total_gross_equity;
    if((totalPpc/ppcDivisible) >= 0){
      totals['avgPpc'] = totalPpc /ppcDivisible
    }
    if((totalHardDebt/debtDivisible) >= 0){
      totals['avgDebt'] = totalHardDebt / debtDivisible;
    }
    totals['subtotals'] = subtotals;
    return totals;
  }
  public expandPanel(event:any){
    event.isExpanded = !event.isExpanded;
  }

  private _getLocation(project:any){
    let location = {locationString: "", county: ""}
    if(project.properties.length>0){
      if(project.properties[0].entity.entityAddresses.length> 0){
        let address = project.properties[0].entity.entityAddresses[0].address
        location.locationString += address.zipCode.city
        location.locationString += ', '
        location.locationString += address.zipCode.state.abbreviation
        location.county = address.zipCode.county.name
      }
    }
    return location
  }

  public fetchProjectStatus = (statuses:any[]) => {
    let foundStatus = statuses.find((status:any) => {
      return status.active && status.statusSequence.name == 'Syndications'
    })
    if(foundStatus){
      return {name: foundStatus.status.name, id: foundStatus.id}
    } else {
      let activeStatus = statuses.filter((status:any) => status.active==true);
      return {name: activeStatus[0].status.name, id: activeStatus[0].id}
    }
  }

  openAddSyndicationsPipelineModal(){
    let dialogRef = this.dialog.open(AddSyndicationsPipelineComponent, {
      width: '1200px',
      height: '750px'
    })
  }

  private _combineCredts(outlets:any){
    let projectCredits:any[] = []
    let filteredOutlets:any[] = []
    for(let f = 0; f < outlets.length; f++){
      if(outlets[f].projectCredit!==null){
        projectCredits.push(outlets[f].projectCredit)
      }
    }
    projectCredits.forEach((prc:any) => {

      let localCreditOutlets = outlets.filter((outlet:any) => outlet.projectCredit.id == prc.id)
      if(localCreditOutlets.length>0){
        let totalOwnership = 0;
        localCreditOutlets.forEach((lco:any) => {
          totalOwnership += lco.ownership
        })

        if(totalOwnership > 98.0){
          localCreditOutlets.forEach((loct:any) => {
            if(loct.fundProjectState!==null && loct.fundProjectState.name!=='Admitted'){
              filteredOutlets.push(loct)
            }
          })
        } else {
          localCreditOutlets.forEach((loct:any) => {
            let oldPc = {...loct, val: 'old'}
            let newPc = {...loct, estimOwnership: 100 - loct.ownership, val: 'new'}
            // if(newPc.fundProjectState !== null && (newPc.fundProjectState?.name == 'Exited' || newPc.fundProjectState?.name == 'Admitted') ){
            //   newPc.fundProjectState = null
            // }
            if(newPc.fundProjectState !== null){
              newPc.fundProjectState = null
            }
            newPc.fund = null
            newPc.certificatedOutlet = null
            filteredOutlets.push(newPc)
            filteredOutlets.push(oldPc)
            // if(oldPc.fundProjectState !==null && oldPc.fundProjectState.name == 'Admitted'){
            //   oldPc.fundProjectState = null
            //   filteredOutlets.push(oldPc)
            // }
          })
        }
      }
    })

    return filteredOutlets


  }

  private _sortSubCredits(credits:any){
    let customOrder = ['Federal LIHTC', 'Federal Energy', 'Federal Historic', 'State LIHTC', 'State Energy', 'State Historic']
    let sortedOrder:any = []
    let values = [...credits]
    sortedOrder = values.sort((k1:any,k2:any) => {
      let k1Type = k1.projectCredit.taxCreditType.level + " " + k1.projectCredit.taxCreditType.name;
      let k2Type = k2.projectCredit.taxCreditType.level + " " + k2.projectCredit.taxCreditType.name;
      const indexA = customOrder.indexOf(k1Type)
      const indexB = customOrder.indexOf(k2Type)
      if(indexA === -1 && indexB === -1){
        return k1Type.localeCompare(k2Type)
      } else if (indexA === -1){
        return 1
      } else if (indexB === -1){
        return -1;
      } else {
        return indexA - indexB
      }
    })
    return sortedOrder
  }

  public openAssignmentsModal(event:any){
    let dialogRef = this.dialog.open(AssignmentsModalComponent, {
      width: '1200px',
      data: {
        projectCreditId: event.credit_id,
        projectId: event.projectid,
        status: event.project_status,
        project: event.project,
        projecturl: event.projecturl,
        sponsor: event.sponsor,
        closing_date: event.closing_date,
        sponsorurl: event.sponsorurl,
        fundProjectStates: this.fundProjectStates,
        sequenceStatuses: this.syndicationsSequences,
        type: 'Syndications',
      }
    })
    let componentInstance = dialogRef.componentInstance.onSave.subscribe((data:any) => {
      let keys = Object.keys(data);
      let outlets:any[] = []
      for(let i = 0; i < keys.length; i++){
        outlets.push(...data[keys[i]]);
      }
      let outletData:any[] = []
      for(let i = 0; i < outlets.length; i++){
        let outletObj = {
          ut_irr: outlets[i].value.ut_irr,
          revenue_year: outlets[i].value.revenue_year,
          ownership: outlets[i].value.ownership,
          credit_id: outlets[i].value.credit_id,
          outlet_id: outlets[i].value.outlet_id,
          fund_id: outlets[i].value.fund_id,
          certificated_outlet_id: outlets[i].value.certificated_outlet_id,
          equity_amount: outlets[i].value.gross_equity,
          estimated_gross_equity: outlets[i].value.estimated_gross_equity,
          load_percentage: outlets[i].value.load,
          admitted_date: this.datePipe.transform(outlets[i].value.admitted_date, 'yyyy-MM-dd'),
          is_target_exit: outlets[i].value.is_target_exit,
          is_target: outlets[i].value.is_target,
          exit_date: this.datePipe.transform(outlets[i].value.exit_date, 'yyyy-MM-dd'),
          fund_project_state_id: outlets[i].value.placement_status,
          warehoused: outlets[i].value.warehoused,
          loadWeight: outlets[i].value.loadWeight,
          notes: outlets[i].value.notes,
          investor_approval_date: this.datePipe.transform(outlets[i].value.investor_approval_date, 'yyyy-MM-dd'),
          projected_warehouse_days: outlets[i].value.projected_warehouse_days,
          is_target_investor_approval: outlets[i].value.is_target_investor_approval
        }
        outletData.push(outletObj)
      }

      if(outletData.length>0){
        let saved_successes = 0;
        for(let g = 0; g < outletData.length; g++){
          if(outletData[g].outlet_id!==null && outletData[g].credit_id!==null){
            outletData[g].gross_equity = outletData[g].gross_equity / (outletData[g].ownership / .01) / outletData[g].loadWeight;
            this.fundService.updateProjectCredit(outletData[g], (response:any) => {
              this.syndicationsService.updateSyndicationsPipeline(response.data.updateProjectCreditOutlet, UpdateSyndicationsPipelineMode.UPDATE)
              saved_successes += 1;
              if(saved_successes == outletData.length){
                this.openSnackBar('Credits saved.', 'save-success')
                // setTimeout(() => {
                //   this.queryRef.refetch().then((response) => {
                //     this.projects = this._setSyndicationsProjects(response.data.syndicationsProjectCredits);
                //     this.fundProjectStates = response.data.fund_project_states;
                //   })
                // }, 2000)
              }
            })
          } else {
            let outletVar = {
              project_credit_id: outletData[g].credit_id,
              fund_id: outletData[g].fund_id,
              certificated_outlet_id: outletData[g].certificated_outlet_id,
              fund_project_state_id: outletData[g].fund_project_state_id,
              ownership: outletData[g].ownership,
              estimated_gross_equity: outletData[g].estimated_gross_equity,
              gross_equity: null,
              purchase_amount: null,
              admitted_date: this.datePipe.transform(outletData[g].admitted_date, 'yyyy-MM-dd'),
              exit_date: outletData[g].exit_date !== null ? this.datePipe.transform(outletData[g].exit_date, 'yyyy-MM-dd') : null,
              is_target: outletData[g].is_target ?? false,
              is_target_exit: outletData[g].is_target_exit ?? false,
              warehoused: outletData[g].warehoused,
              is_target_investor_approval: outletData[g].is_target_investor_approval,
              investor_approval_date: outletData[g].investor_approval_date,
              projected_warehouse_days: outletData[g].projected_warehouse_days,
              revenue_year: outletData[g].revenue_year,
              is_revenue_flagged: false,
              load_percentage: outletData[g].load_percentage,
              ut_irr: outletData[g].ut_irr
            }
            this.fundService.createProjectCreditOutlet(outletVar, (response:any) => {
              this.syndicationsService.updateSyndicationsPipeline(response.data.createProjectCreditOutlet, UpdateSyndicationsPipelineMode.ADD)
              saved_successes += 1
              if(saved_successes == outletData.length){
                this.openSnackBar('Credits saved.', 'save-success')
                // setTimeout(() => {
                //   this.queryRef.refetch().then((response) => {
                //     this.projects = this._setSyndicationsProjects(response.data.syndicationsProjectCredits);
                //     this.fundProjectStates = response.data.fund_project_states;
                //   })
                // },2000)
              }
            })
          }
        }
      }

      dialogRef.close()
    })

    let removeInstance = dialogRef.componentInstance.onRemove.subscribe((data:string) => {
      this.fundService.deleteProjectCredit(data, (response:any) => {
        this.syndicationsService.updateSyndicationsPipeline(data, UpdateSyndicationsPipelineMode.REMOVE)
        this.openSnackBar('Credit outlet removed', 'save-success')
        // setTimeout(() => {
        //   this.queryRef.refetch().then((response) => {
        //     this.projects = this._setSyndicationsProjects(response.data.syndicationsProjectCredits);
        //     this.fundProjectStates = response.data.fund_project_states;
        //   })
        // }, 2000)
      });
    })

    let subscribeInstance = dialogRef.componentInstance.onSubscribe.subscribe((data:any) => {
      this.queryRef.refetch().then((response) => {
        this.projects = this._setSyndicationsProjects(response.data.syndicationsProjectCredits);
        this.fundProjectStates = response.data.fund_project_states;
      })
    })
  }

  openTagModal(tagged:any[]){
    let items:any[] = []
    tagged.forEach((tag:any) => {
      let person = tag.person!==null ? tag.person.name : null;
      let role = tag.role.name
      let organization = tag.organization !== null ? tag.organization.name : null;
      let sponsor = tag.sponsor !== null ? tag.sponsor.name : null
      let keyValue:any = {
        key: role,
        value: person !== null ? person : organization!== null ? organization : sponsor !== null ? sponsor.name : null,
      }
      items.push(keyValue)
    })
    let dialogRef = this.dialog.open(SimpleListModalComponent, {
      data: {
        items: items
      }
    })
  }

  public sortData(key:any, stateKey:any, event:any){
    let field = event.active
    let direction = event.direction
    this.projects[stateKey][key] = [...this.projects[stateKey][key]].sort((a:any, b:any) => {
      if(field=='fund' && a.fund_name!==null){
        a[field] = a.fund_name
      }
      if(field=='fund' && b.fund_name!==null){
        b[field] = b.fund_name
      }
      if(field=='fund' && a.certificated_name!==null){
        a[field] = a.certificated_name
      }
      if(field=='fund' && b.certificated_name!==null){
        b[field] = b.certificated_name
      }
      let aVal = a[field] ?? ""
      let bVal = b[field] ?? ""
      if(direction == 'asc'){
        return aVal.toString().localeCompare(bVal.toString())
      } else if(direction == 'desc'){
        return bVal.toString().localeCompare(aVal.toString())
      } else {
        return 0
      }
    })

  }

  public formatStatusClass(status:string){
    let splits = status.split(" ");
    if(splits.length==1){
      return splits[0].toLowerCase()
    } else if(splits.length>1){
      return splits.join("-").toLowerCase()
    }
    return status.toLowerCase()
  }

  private openSnackBar(message: string, panel_class:string) {
    const config = new MatSnackBarConfig();
    config.panelClass = panel_class !== null ? [panel_class] : ['save-success'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }

  ngOnDestroy(){
    this.projectsSub.unsubscribe();
  }

  protected readonly Object = Object;
}
